export default "__VITE_ASSET__d8df6799__"